import * as r from "react";
import { forwardRef as l } from "react";
import { c as o } from "./index.js-Cr0Rsuyz.mjs";
function a(e, t) {
  return /* @__PURE__ */ r.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t
  }, e), /* @__PURE__ */ r.createElement("path", {
    fill: "currentColor",
    d: "M11.21 7.03a1.25 1.25 0 0 1 1.674.086l7 7a1.25 1.25 0 0 1-1.768 1.768L12 9.768l-6.116 6.116a1.25 1.25 0 1 1-1.768-1.768l7-7z"
  }));
}
var c = o(/* @__PURE__ */ l(a));
export {
  c as I
};
